export enum WorkStatus {
  SUCCESS,
  ERROR,
  CANCELLED,
}
